import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './projectCalendarSetup.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import create_projectCalendar from '../../../../WidgetCollection/ms_teams/confpan/channel_tab_configuration/create_projectCalendar/create_projectCalendar';
import lang from 'dojo/_base/lang';
import { teamsTabConfiguration, TeamsTabWidgetName } from "../../teamTypes";

class projectCalendarSetup extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private mainContentContainer:HTMLDivElement;
    private createWidget:MdsLax<InstanceType<typeof create_projectCalendar>>;

    private saveBtnTxt:HTMLSpanElement;
    private cancelBtnTxt:HTMLSpanElement;
    private saveBtn:HTMLButtonElement;
    private titleSpan:HTMLSpanElement;
    private value: { projectEntityClassname: string, projectEntityId: string } = { projectEntityClassname: null, projectEntityId:null };
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        window.msTeamsSimpleApi.managerHideSettingsButton(true);

        this.cancelBtnTxt.innerHTML = this.translate("General_Cancel");
        this.saveBtnTxt.innerHTML = this.translate("General_Save_And_Apply");
        this.titleSpan.innerHTML = this.translate("MsTeamsIntegration_AdminPanel_TabConf_NewProjectCalendar");

        this.createWidget = new create_projectCalendar();
        this.createWidget.placeAt(this.mainContentContainer);
        this.createWidget.hideDisplayNameInput(true);
        this.createWidget.on("valueChange", lang.hitch(this, this._onChange_Value));
    }

    private _onChange_Value(val: { msTeamsChannelEntityId: string, displayName: string, projectEntityId: string, projectEntityClassname: string }){
        if ((typeof val?.projectEntityClassname != 'string') || (typeof val?.projectEntityId != 'string') ){
            this.saveBtn.disabled = true;
            return;
        }
        this.saveBtn.disabled = false;

        this.value.projectEntityClassname = val.projectEntityClassname;
        this.value.projectEntityId = val.projectEntityId;
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    private async _onClick_returnAction(ev:Event){
        this.StandbyStart();
        await this.overWriteTabState('tabSetup');
        this.StandbyStop();
    }
    private async _onClick_SaveAction(ev:Event){
        let isSuccess = true;
        this.StandbyStart();

        let jsonBodyData = {
            teamID: window.msTeamsSimpleApi?.metadata?.context?.team?.groupId ?? "",
            channelID: window.msTeamsSimpleApi?.metadata?.context?.channel?.id ?? "",
            tabID: window.msTeamsSimpleApi?.helperFn?.getTabID(),
            newProjectCalendar: {
                classID: this.value.projectEntityId,
                className: this.value.projectEntityClassname
            }
        };

        let prom:Promise<{}> = new Promise((resolve, reject) => {
            this.RequestManager.callfunction(
                "Webtool_API_Webcalendar__ProjectCalendar_CreateNewFromInsideTab",
                jsonBodyData,
                lang.hitch(this, (result:any) => {
                    resolve(result);
                }),
                lang.hitch(this, (err) => {
                    console.error(err.Message);
                    this.showToast(err.Message, "fas fa-exclamation-circle");
                    reject(err);
                })
            );
        });

        try{
            await prom;
        }catch{
            isSuccess = false;
        }

        if (isSuccess){
            await this.overWriteTabState('projectCalendar');
        }
        this.StandbyStop();
    }

    private async overWriteTabState(tabName:TeamsTabWidgetName){
        let tabConfigString: string = await window.msTeamsSimpleApi.helperFn.stateGet("system_tabConfiguration");
        if (tabConfigString.trim() == "") {
            tabConfigString = "{}";
        }
        let tabConfig: teamsTabConfiguration = JSON.parse(tabConfigString);
        tabConfig.teamsTabWidgetName = tabName;
        await window.msTeamsSimpleApi.helperFn.stateSet("system_tabConfiguration", JSON.stringify(tabConfig));
        try {
            (window.location.reload as (forcedReload?: boolean) => void)(true);
        } catch {
            window.location.reload();
        }
    }
}

export default mdsWidget(projectCalendarSetup);
